import { FieldError } from "react-hook-form";
import { WHITE_SPACE_ERROR_SPACE } from "utils/constants/Messages";
import {
  CONTACT_NOTE_MAX_LENGTH,
  MAX_BYTE_VALUE,
  MAX_INT_VALUE,
} from "utils/constants/constant";
import {
  PERSONAL_SMART_GOALS_MAX_LENGTH,
  VARIANCE_MAX_LENGTH,
} from "utils/constants/slp";

export const getStudentIdError = (errors?: FieldError): string => {
  if (errors) {
    if (errors.type === "required") {
      return "Student ID is required";
    }
    if (errors.type === "pattern") {
      return `Student ID ${WHITE_SPACE_ERROR_SPACE}`;
    }
    if (errors.type === "max") {
      return `Max value of Student ID can be '${MAX_INT_VALUE}'`;
    }
  }

  return "";
};

export const getNumberOfCompletedSLPError = (errors?: FieldError): string => {
  if (errors) {
    if (errors.type === "max") {
      return `Max value of No. of Completed SLPs can be '${MAX_BYTE_VALUE}'`;
    }
  }

  return "";
};

export const getSLPContactNoteError = (errors?: FieldError): string => {
  if (errors) {
    if (errors.type === "maxLength")
      return `Maximum length of Contact Note should be ${CONTACT_NOTE_MAX_LENGTH}`;
    if (errors.type === "pattern")
      return `Contact Note ${WHITE_SPACE_ERROR_SPACE}`;
  }

  return "";
};

export const getAllocatedToError = (errors?: FieldError): string => {
  if (errors && errors.type === "required")
    return "Please select at least one PLA";

  return "";
};

export const getSlpConductedByError = (errors?: FieldError): string => {
  if (errors && errors.type === "required")
    return "SLP Conducted By is required";

  return "";
};

export const getStudentGoalError = (errors?: FieldError): string => {
  if (errors) {
    if (errors.type === "required") return "Student Goal is required";

    if (errors.type === "maxLength")
      return `Maximum length of student goal should be ${PERSONAL_SMART_GOALS_MAX_LENGTH}`;

    if (errors.type === "pattern")
      return `Student goal ${WHITE_SPACE_ERROR_SPACE}`;
  }

  return "";
};

export const getSmartGoalError = (errors?: FieldError): string => {
  if (errors) {
    if (errors.type === "required") return "Smart Goal is required";

    if (errors.type === "maxLength")
      return `Maximum length of smart goal should be ${PERSONAL_SMART_GOALS_MAX_LENGTH}`;

    if (errors.type === "pattern")
      return `Smart goal ${WHITE_SPACE_ERROR_SPACE}`;
  }

  return "";
};

export const getBaselineLevelError = (errors?: FieldError): string => {
  if (errors) {
    if (errors.type === "required") return "Baseline Level is required";

    if (errors.type === "maxLength")
      return `Maximum length of baseline level should be ${PERSONAL_SMART_GOALS_MAX_LENGTH}`;

    if (errors.type === "pattern")
      return `Baseline level ${WHITE_SPACE_ERROR_SPACE}`;
  }

  return "";
};

export const getImportanceError = (errors?: FieldError): string => {
  if (errors && errors.type === "validate") return "Importance is required";

  return "";
};

export const getDifficultyError = (errors?: FieldError): string => {
  if (errors && errors.type === "validate") return "Difficulty is required";

  return "";
};

export const getAssessedDateError = (errors?: FieldError): string => {
  if (errors && errors.type === "required")
    return "Goal Assessment date is required";

  return "";
};

export const getAchievementRatingError = (errors?: FieldError): string => {
  if (errors && errors.type === "required")
    return "Achievement rating is required";

  return "";
};

export const getVarianceError = (errors?: FieldError): string => {
  if (errors && errors.type === "maxLength")
    return `Maximum length of baseline level should be ${VARIANCE_MAX_LENGTH}`;
  if (errors && errors.type === "pattern")
    return `Variance ${WHITE_SPACE_ERROR_SPACE}`;

  return "";
};

export const sLPCompletedOnDateError = (errors?: FieldError): string => {
  if (errors && errors.type === "required") return "Date Completed is required";
  if (errors && errors.type === "validate")
    return "Completed SLP Date cannot be greater than today's date";

  return "";
};

export const nextSLPDueDateError = (errors?: FieldError): string => {
  if (errors && errors.type === "required")
    return "Next SLP Due Date is required";
  if (errors && errors.type === "validate") {
    return "Next SLP Due Date cannot be earlier than today's date";
  }

  return "";
};

export const slpAnswerWhiteSpaceError = (errors?: FieldError): string => {
  if (errors && errors.type === "pattern")
    return `Answer ${WHITE_SPACE_ERROR_SPACE}`;

  return "";
};

export const getSLPParticipationError = (errors?: FieldError): string => {
  if (errors && errors.type === "required")
    return "Please select at least one SLP Participation value";

  return "";
};
